// extracted by mini-css-extract-plugin
module.exports = {"drawer":"style_drawer__gXt0b"};